import React, { FC } from "react";
import { Button, Popconfirm, Space, Spin, Typography } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import useHasPermissions from "hooks/useHasPermissions";
import { Permission } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import Header from "components/layout/Header";

import OrganizationForm from "../OrganizationForm";

import { useOrganizationDetails } from "./hooks";

const OrganizationDetails: FC = () => {
  const { initialValues, loading, deleteOrganization } =
    useOrganizationDetails();
  const intl = useIntl();
  const canDeleteOrganization = useHasPermissions([
    Permission.ORGANIZATION_DELETE,
  ]);

  if (loading) return <Spin />;

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage
            defaultMessage="{name} details"
            values={{ name: initialValues.input.name }}
          />
        </Typography.Title>
      </Header>
      <Space />
      <OrganizationForm
        loading={loading}
        initialValues={initialValues}
        isReadOnly
      />
      {canDeleteOrganization && (
        <Popconfirm
          title={intl.formatMessage({
            defaultMessage: "Are you sure?",
          })}
          onConfirm={deleteOrganization}
        >
          <Button type="primary" danger htmlType="button">
            <FormattedMessage defaultMessage="Delete Organization" />
          </Button>
        </Popconfirm>
      )}
    </>
  );
};

export default OrganizationDetails;
